import { render, staticRenderFns } from "./AssetSwitch.vue?vue&type=template&id=5efc7bda&"
import script from "./AssetSwitch.vue?vue&type=script&lang=js&"
export * from "./AssetSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports